const addScrollIntoViewListener = (function scrollIntoViewListener() {
	let isListening = false;
	let listeners = [];



	function scrollListener() {
		listeners = listeners.filter((listener) => {
			const rect = listener.domElement.getBoundingClientRect();
			
			if (rect.top <= window.innerHeight) {
				listener.callback();
				return false;
			}
	
			return true;
		});
	
		if (listeners.length === 0) {
			window.removeEventListener('scroll', scrollListener, { passive: true });
			isListening = false;
		}
	}



	function addScrollIntoViewListener(domElement, callback) {
		const rect = domElement.getBoundingClientRect();
	
		if (rect.top <= window.innerHeight) {
			callback();
			return;
		}
	
		if (!isListening) {
			window.addEventListener('scroll', scrollListener, { passive: true });
			isListening = true;
		}
	
		listeners.push({
			domElement,
			callback,
		});
	}



	return addScrollIntoViewListener;
})();
